let obj = {
    current_password: '',
    password: '',
    password_confirmation: ''
}
export default obj;